import './myCss.css'
import boston from './gallery/boston.jpg'
import ghibli from './gallery/ghibli.jpg'
import skiSlopes from './gallery/skiSlopes.jpg'
import bkbridge from './gallery/bkbridge.jpg'

function Gallery() {
    return (
        <>
            <div id='grid'>

                <div className='grid-item-1'>
                    <img className='photo-project-2' src={skiSlopes} alt='ski slopes' value='ski slopes' />
                    <h5 id='desc'>Ski Slopes</h5>
                </div>
                <div className='grid-item-1'>
                    <img className='photo-project-2' src={bkbridge} alt='my borough' value='my borough' />
                    <h5 id='desc'>My borough</h5>
                </div>
                <div className='grid-item-1'>
                    <img className='photo-project-2' src={ghibli} alt='AI Art' value='ai art' />
                    <h5 id='desc'>AI Art</h5>
                </div>
                <div className='grid-item-1'>
                    <img className='photo-project-2' src={boston} alt='boston' value='boston' />
                    <h5 id='desc'>Backdrops</h5>
                </div>
            </div>
        </>
    )
}

export default Gallery;
